import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";
import type { Contact } from "../types";
import { ageFromDateOfBirth } from "./playerAge";

/** "Player · 7" or "Guardian · (214) 555-0137" next to a person's name. */
export const ChampPersonBadges = ({ contact }: { contact: Contact }) => {
  const translate = useTranslate();
  const isPlayer = contact.role === "player";
  const age = isPlayer ? ageFromDateOfBirth(contact.date_of_birth) : null;
  const phone = !isPlayer ? contact.phone_jsonb?.[0]?.number : undefined;

  return (
    <span className="flex items-center gap-2 text-xs font-normal">
      <Badge variant={isPlayer ? "default" : "outline"}>
        {translate(`resources.contacts.roles.${contact.role ?? "guardian"}`)}
      </Badge>
      {age !== null && (
        <span className="text-muted-foreground">
          {translate("resources.contacts.age_short", { smart_count: age })}
        </span>
      )}
      {phone && <span className="text-muted-foreground">{phone}</span>}
    </span>
  );
};
